module.exports = __webpack_public_path__ + "img/AUS.f1fde7f2.svg";